import { mainApiAxios as axios } from '@/plugins/axios'


export default {
    listContactForm() {
        return axios.get('ContactForm')
    },

    AddContactItem(contactFormQuestions) {
        return axios.post('ContactForm/Create-ContactItem', contactFormQuestions, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    UpdateContactItem(lstContactFormItem) {        
        return axios.post('ContactForm/Update-ContactItem', lstContactFormItem, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    updateLookupItem(lookupItemId, lookupItemObj) {
        return axios.put(`lookupsAdmin/updateLookupItem/${lookupItemId}`, lookupItemObj, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },

    DeleteContactItem(formQuestionId) {
        return axios.post(`ContactForm/DeleteContactForm/${formQuestionId}`)
    }
}